module.exports = __webpack_public_path__ + "img/file-earmark-check-fill.d22bf17d.svg";